module.exports = __webpack_public_path__ + "static/media/logo.2299d33e.png";